var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAcute = function SvgAcute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.908 19.5q-3.143 0-5.324-2.181t-2.18-5.323q0-3.12 2.18-5.307 2.181-2.19 5.324-2.189 3.119 0 5.307 2.189t2.188 5.307q0 3.143-2.188 5.323-2.19 2.181-5.307 2.181m-.005-1.5q2.5 0 4.25-1.75t1.75-4.25-1.75-4.25T14.903 6t-4.25 1.75T8.903 12t1.75 4.25 4.25 1.75m2.371-2.535 1.07-1.069-2.69-2.69V8.154h-1.5v4.165zM2.596 8.75v-1.5h3.807v1.5zm-1 4v-1.5h4.807v1.5zm1 4v-1.5h3.807v1.5z"
  })));
};
export default SvgAcute;